const maxAge = 60 * 3;
const refreshTokenMaxAge = 60 * 60 * 24 * 7;
const secure = false;
export {
  maxAge as m,
  refreshTokenMaxAge as r,
  secure as s
};
